import { useEffect } from 'react';

import { useAnalyticsContext } from '../../../modules/analytics/AnalyticsContext';
import type { TrackPageOptions } from '../../../modules/analytics/types';

export default (
  eventName: string,
  page: string,
  pageOptions: TrackPageOptions = {},
) => {
  const {
    analytics: { trackPageView },
  } = useAnalyticsContext();
  const { passwordlessAuthentication } = pageOptions;
  useEffect(() => {
    trackPageView({ eventName, page, passwordlessAuthentication });
  }, [trackPageView, eventName, page, passwordlessAuthentication]);
};
